import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AiFillHome } from 'react-icons/ai';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import StayCard from '../common/StayCard';
import Loading from '../ui/Loading';
import AltTripCard from '../common/AltTripCard';
import { useSEO } from '../../custom hooks/useSEO';
import Cookies from 'js-cookie';

const Favorite = () => {
    const { t } = useTranslation();
    const { t: tSeo } = useTranslation("seo");
    const userId =Cookies.get("userId")
    const seo = useSEO({
        title: tSeo("favorite.title"),
        description: tSeo("favorite.description")
    });
    const { favorites, loading } = useSelector((state: RootState) => state.favoriteslice);
    const [selectedType, setSelectedType] = useState<'stays' | 'trips' | 'halls'>('stays');


    const selectedItems = favorites?.[selectedType] || [];

    if (loading) return <Loading />;

    const renderCard = (item: any, index: number) => {
        switch (selectedType) {
            case 'stays':
                return <StayCard key={index} stay={item.place} userId={userId} />;
            case 'halls':
                return <StayCard key={index} stay={item.place} userId={userId}/>;
            case 'trips':
                return <AltTripCard key={index} trip={item.trip} />;
            default:
                return null;
        }
    };

    return (
        <div>
            {seo}
            {/* Header */}
            <div className='green-hero flex-center relative main-prop xs:h-full md:h-[70vh] padding-container'>
                <div className="relative z-20 mb-2 text-white text-center py-10">
                    <h1 className="text-4xl font-bold">{t('favorite')}</h1>
                    <div className="flex items-center justify-center gap-1 text-base">
                        <AiFillHome className="mr-1 text-white text-lg" />
                        <span>{t('home')}</span>
                        <span className="mx-2">/</span>
                        <span>{t('favorite')}</span>
                    </div>
                </div>
            </div>

            {/* Content */}
            <div className='padding-container main-prop'>
                <div className='w-full flex justify-between items-center'>
                    <h3 className="text-xl font-semibold mb-4">
                        {`${t("your-favorites")} (${selectedItems.length})`}
                    </h3>

                    <div>
                        <label>{t("type")}: </label>
                        <select
                            value={selectedType}
                            onChange={(e) => setSelectedType(e.target.value as 'stays' | 'trips' | 'halls')}
                            className="focus:outline-none px-4 py-1 rounded-md shadow-sm bg-grayColor text-textSecond"
                        >
                            <option value="stays">{t("stays")}</option>
                            <option value="trips">{t("trips")}</option>
                            <option value="halls">{t("halls")}</option>
                        </select>
                    </div>
                </div>

                {/* Items */}
                {Array.isArray(selectedItems) && selectedItems.length > 0 ? (
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 mt-4">
                        {selectedItems.map((item: any, index: number) => renderCard(item, index))}
                    </div>
                ) : (
                    <div className="flex-center flex-col text-center text-gray-500 mt-4">
                        <img src="/asset/empty.png" alt="empty" />
                        {t("no-favorites")}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Favorite;
